/**
 * Backend API base URL.
 *
 * Production (served from a real domain, e.g. https://www.adelgroups.com):
 *   returns "" so the browser calls the API on the SAME origin —
 *   https://www.adelgroups.com/api/... — and the reverse proxy (nginx in the
 *   frontend container, optionally Caddy in front) forwards /api to the backend.
 *   No cross-port, no mixed-content, no CORS.
 *
 * Local dev (localhost / 127.0.0.1): talks to the backend dev port on :8010.
 *
 * Override anytime with VITE_BACKEND_URL (e.g. a separate https://api.adelgroups.com).
 */
export function getApiBaseUrl() {
  const env = import.meta.env.VITE_BACKEND_URL;
  if (env) return env; // explicit override always wins
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return 'http://localhost:8010';
    }
    return ''; // same-origin — the reverse proxy routes /api to the backend
  }
  return ''; // SSG prerender (no window); relative, not used for runtime fetches
}
